import bus, { EVENT } from '@videotools/js/events';
import { trans } from '@videotools/js/util/transHelpers';
import { VideoCreateZeroDurationError } from '@videotools/js/store/modules/video-create';

export const showVideoCreateErrorToast = (error) => {
	let msg = trans('one.video_export.general_error');

	if (error && error instanceof VideoCreateZeroDurationError) {
		msg = trans('one.video_export.tags_no_duration');

		bus.publish(
			EVENT.ERROR,
			msg,
		);
	}
};
